import styles from './OrganizationAssignment.module.scss';

import { AssignmentViewModel } from 'chaika-frontend-types/frontend-cms';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { OrganizationItem } from '@common/CreationMenuFields/OrganizationAssignment/OrganizationItem';
import { useOrganizationAssignment } from '@common/CreationMenuFields/OrganizationAssignment/hooks/useOrganizationAssignment';
import { translate } from '@chaika/i18n/helper';

interface Props {
    value: AssignmentViewModel[];
    dataTest: string;
    title?: string;
    onChange(params: any): void;
}

export const OrganizationAssignment = ({ value, onChange, dataTest, title }: Props) => {
    const { options, selectedOrganizations, onItemChange, onDelete, addEmptyItem } = useOrganizationAssignment({
        value,
        onChange,
    });

    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            {selectedOrganizations.length > 0 && (
                <div className={styles.organizations}>
                    {selectedOrganizations.map((item, index) => (
                        <OrganizationItem
                            key={`${dataTest}_${item.id}`}
                            item={item}
                            onDelete={() => onDelete(index)}
                            options={options}
                            selectedIds={selectedOrganizations.map(item => item.organizationId)}
                            dataTest={`${dataTest}_${item.id}`}
                            onChange={value => onItemChange(value, index)}
                        />
                    ))}
                </div>
            )}
            <div className={styles.button}>
                <Button
                    disabled={
                        selectedOrganizations.length > 0 && !!selectedOrganizations.find(item => !item.organizationId)
                    }
                    theme={ButtonTheme.Secondary}
                    modifiers={[ButtonModifiers.Small, ButtonModifiers.InheritWidth]}
                    dataTest={`${dataTest}_add`}
                    label={`+ ${translate('addDestination')}`}
                    onClick={addEmptyItem}
                />
            </div>
        </div>
    );
};
